import { LOGO_URL, BRAND_NAME } from "./brand";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#FAFCF5] border-t border-[#E6EFD8] overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-6">
                    <a href="#top" className="inline-flex items-center" data-testid="footer-logo">
                        <img
                            src={LOGO_URL}
                            alt={BRAND_NAME}
                            className="h-12 sm:h-14 w-auto"
                            draggable={false}
                        />
                    </a>
                    <p className="mt-6 text-2xl sm:text-4xl font-bold text-[#1F2A23] leading-[1.15]">
                        世界をもっと、
                        <br />
                        <span className="text-[#7DB856]">やさしく</span>、
                        <span className="text-[#7DB856]">まるく</span>、しよう。
                    </p>
                </div>

                <div className="md:col-span-3">
                    <div className="text-xs font-bold tracking-widest uppercase text-[#8A9690]">
                        サイトマップ
                    </div>
                    <ul className="mt-4 space-y-2 text-[#2F5F1A] font-bold">
                        {[
                            ["#works", "制作実績"],
                            ["#worries", "できること"],
                            ["#process", "開発の流れ"],
                            ["#about", "会社概要"],
                            ["#contact", "お問い合わせ"],
                        ].map(([h, l]) => (
                            <li key={h}>
                                <a
                                    href={h}
                                    data-testid={`footer-link-${l}`}
                                    className="hover:text-[#7DB856] transition-colors"
                                >
                                    {l}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <div className="text-xs font-bold tracking-widest uppercase text-[#8A9690]">
                        運営
                    </div>
                    <div className="mt-4 text-[#2F5F1A] font-bold">
                        株式会社フレッシュエージェント
                    </div>
                    <p className="mt-2 text-sm text-[#5C6B5E] leading-relaxed">
                        中小企業向け業務改善Webアプリの企画・開発・運用支援。
                    </p>
                </div>
            </div>

            <div className="border-t border-[#E6EFD8]">
                <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs sm:text-sm font-bold text-[#8A9690]">
                    <span>
                        © {new Date().getFullYear()} {BRAND_NAME} / 株式会社フレッシュエージェント
                    </span>
                    <span className="font-accent">Made with まる ◯ in Japan</span>
                </div>
            </div>
        </footer>
    );
}
